import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import ScriptLoadingMap from 'shared/components/Map/ScriptLoadingMap';
import ModalContainer from 'shared/components/ModalContainer/ModalContainer';
import s from './FirmLocation.css';

const FirmLocation = props => (
  <ModalContainer modalCN={props.modalCN} isOpen={props.isOpen} onClose={props.onClose}>
    <div className={s.mapInfo}>
      <div className={s.mapInfoTitle}>{props.title}</div>
      <div>
        <i className={`fa fa-map-marker ${s.mapLocationIcon}`} /> {props.address}
      </div>
      <a href="" className={s.closeMap} onClick={props.onClose}>
        <i className={s.closeMapIcon} />
      </a>
    </div>
    {props.geoLocation && (
      <ScriptLoadingMap
        markers={[
          {
            title: props.title,
            position: { lat: props.geoLocation.lat, lng: props.geoLocation.lon },
          },
        ]}
        defaultCenter={{ lat: props.geoLocation.lat, lng: props.geoLocation.lon }}
        containerElement={<div className={s.mapContainer} />}
        mapElement={<div className={s.map} />}
      />
    )}
  </ModalContainer>
);

FirmLocation.propTypes = {
  title: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  modalCN: PropTypes.string.isRequired,
  geoLocation: PropTypes.shape().isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(s)(FirmLocation);



// WEBPACK FOOTER //
// ./src/shared/components/FirmLocation/FirmLocation.js